module.exports = __webpack_public_path__ + "prod/1.42.2/img/education-chain.ef4716d9.png";